import api from "@/services/api";

export default {
  install(Vue) {
    Vue.prototype.$http = api;
    // Object.defineProperties(Vue.prototype, {
    //   $http: api
    // });
  },
};
